module.exports = __webpack_public_path__ + "img/7.ad8f1abf.png";